import React, { useCallback, useEffect, useState } from 'react';
import Spinner from '../../components/Spinner';
import Breadcrumbs from '../../components/BreadCrumbs';
import { useSelector } from 'react-redux';
import {
  RootState,
  secureMessageRequest,
  secureMessageOptionsRequest,
  useAppDispatch,
  useProductName,
  useraccountDetailsRequest,
  environment,
} from '@rb-serve-app/core';
import Button from '../../components/Button';
import Pagination from './Pagination';
import MessageCard from './MessageCard';
import ViewMessageDetail from './ViewMessageDetail';
import Modal from 'react-modal';
import CreateMessage from './CreateMessage';
import SuccessModel from '../../components/SuccessModel';
import { useIsMobile } from '../../hooks/useIsMobile';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import { renderDescriptionParagraphs } from '@rb-serve-app/core';
import { logBrazeCustomEvent } from '../../config/braze';

const SecureMessage = () => {
  const { contentfulData } = useSelector(
    (state: RootState) => state.contentful
  );
  const { entries, assets } = contentfulData;

  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [isErrormodalOpen, setIsErrormodalOpen] = useState(false);
  const [isSuccessmodalOpen, setIsSuccessmodalOpen] = useState(false);

  const closeModal = () => {
    setModalIsOpen(false);
  };

  useEffect(() => {
    logBrazeCustomEvent('viewed_secure_messages');
  }, []);

  const { rb_secure_message } = entries;
  const [viewDetailModalOpen, setViewDetailModalOpen] = useState(false);
  const { cardStructure, productName } = useProductName();
  const [isInvalidError, setInvalidError] = useState(false);
  const [localMessages, setLocalMessages] = useState<any[]>([]);
  const [messageDetails, setMessageDetails] = useState(null);
  const [isgenericApierror, setgenericApierror] = useState(false);

  const [currentPage, setCurrentPage] = useState(0); // react-paginate is 0-indexed
  const itemsPerPage = 5;
  const [selectedMessageIndex, setSelectedMessageIndex] = useState<
    number | null
  >(0);
  const [selectedMessageId, setSelectedMessageId] = useState(null);
  const [errorMessage, setErrorMessage] = useState('');
  const [title, setTitle] = useState('');
  const [subTitle, setSubTitle] = useState('');
  const [errorDetails, setErrorDetails] = useState({
    title: rb_secure_message?.secureMessageErrorInfo?.sorryTitle,
    message: rb_secure_message?.secureMessageErrorInfo?.notAbleToSend,
  });
  // Error banner state
  const [errorBannerVisible, setErrorBannerVisible] = useState(false);
  // Error banner state
  const [sucsessBannerVisible, setSucsessBannerVisible] = useState(false);

  const handelSuccessErrorClose = () => {
    setErrorBannerVisible(false);
    setSucsessBannerVisible(false);
    setModalIsOpen(false);
    setInvalidError(false);
    setgenericApierror(false);
  };

  const paginatedMessages = localMessages.slice(
    currentPage * itemsPerPage,
    (currentPage + 1) * itemsPerPage
  );
  useEffect(() => {
    if (currentPage !== 0) {
      setSelectedMessageIndex(null);
    }
  }, [currentPage]);
  // Get secure message data from redux state
  const {
    secureMessageOptions,
    secureMessage,
    secureMessageLoading,
    secureMessageError,
    secureMessageOptionsError,
    updateSecureMessage,
    updateSecureMessageError,
  } = useSelector((state: RootState) => state.contactInfo);

  console.log(secureMessageError, 'secureMessageError', secureMessage);
  // Extract messages from secureMessage state
  const messages = secureMessage?.cases || secureMessage || [];
  useEffect(() => {
    if (messages && messages.length > 0) {
      setLocalMessages([...messages]);
      setSelectedMessageId(messages[0]?.referenceNumber);
    }
  }, [messages]);
  const { customerId, accountId, accountDetails } = useSelector(
    (state: RootState) => state.user
  );
  const dispatch = useAppDispatch();
  const fetchAccountDetails = useCallback(() => {
    if (accountId) {
      if (!accountDetails?.customer?.cardLast4) {
        // dispatch(useraccountDetailsRequest({ accountId, customerId }));
      }
    }
  }, [accountId, customerId, dispatch]);

  useEffect(() => {
    fetchAccountDetails();
  }, [fetchAccountDetails]);

  const breadcrumbs = [
    {
      name: entries?.rb_navigation?.homeLogoTitle,
      href: '/home',
    },
    { name: entries?.rb_secure_message?.headerText, href: '' },
  ];

  const productWithCardLast4 = [
    rb_secure_message?.secureMessageInfo?.myMessageTitle,
    productName,
    accountDetails?.customer?.cardLast4,
  ]
    ?.filter(Boolean)
    ?.join(' ');
  const handleButtonClick = () => {
    setModalIsOpen(true);
  };
  const {
    chat_icon,
    no_messages_icon,
    navigate_next_icon,
    we_are_sorry,
    device_recogonized_success_popup_icon,
  } = assets;

  // Memoized fetch function to avoid recreation on each render
  const fetchMessages = useCallback(() => {
    if (accountId && customerId) {
      dispatch(
        secureMessageRequest({
          accountId,
          customerId,
        })
      );

      // Also fetch message options for categories

      dispatch(
        secureMessageOptionsRequest({
          accountId,
          customerId,
        })
      );
    }
  }, [accountId, customerId, dispatch]);

  useEffect(() => {
    fetchMessages();
  }, [updateSecureMessage]);

  useEffect(() => {
    if (secureMessageError || secureMessageOptionsError) {
      if (secureMessageError) {
        setgenericApierror(true);
      } else {
        setInvalidError(true);
      }
    }
  }, [secureMessageError, secureMessageOptionsError]);

  const isMobile = useIsMobile();
  const handleCardClick = useCallback((messageId: any) => {
    setSelectedMessageId(messageId);
    if (isMobile) {
      setViewDetailModalOpen(true);
    }
  }, []);

  // Effect to handle form submission success/error - modified to prevent immediate navigation on mount
  useEffect(() => {
    if (updateSecureMessage) {
      // Get confirmation number from the response
      const confirmationNumber =
        updateSecureMessage.confirmationNumber ||
        updateSecureMessage.referenceNumber ||
        '-- ----'; // Fallback confirmation number

      // Extract the number part from the full reference if needed
      const extractedNumber = confirmationNumber.includes('-')
        ? confirmationNumber.split('-').pop()
        : confirmationNumber;

      //show success popup
      if (extractedNumber) {
        setTitle(`${rb_secure_message?.successConfirmationMessage}`);
        setSubTitle(
          `${rb_secure_message?.confirmationNumber} ${confirmationNumber}`
        );
        setSucsessBannerVisible(true);
        setErrorBannerVisible(false);
      }
    }

    if (updateSecureMessageError) {
      // Show error banner
      if (
        updateSecureMessageError?.status === '401' ||
        updateSecureMessageError?.errorCode === 'ERR_401_RECAPTCHA_LOW_SCORE'
      ) {
        setTitle(errorDetails?.title);
        setSubTitle(
          entries?.rb_error?.recaptchaErrors?.ERR_401_RECAPTCHA_LOW_SCORE?.title
        );
        setErrorMessage(
          entries?.rb_error?.recaptchaErrors?.ERR_401_RECAPTCHA_LOW_SCORE
            ?.description
        );
        setErrorBannerVisible(true);
        setSucsessBannerVisible(false);
      } else {
        setTitle(rb_secure_message?.secureMessageErrorInfo?.sorryTitle);
        setSubTitle(
          updateSecureMessageError?.message?.detail ||
            "Looks like you're not allowed to perform this action. Please contact customer care team at 1-1800-123-4567."
        );
        setErrorMessage(
          updateSecureMessageError?.message?.detail ||
            "Looks like you're not allowed to perform this action. Please contact customer care team at 1-1800-123-4567."
        );
        setErrorBannerVisible(true);
        setSucsessBannerVisible(false);
      }
    }
  }, [updateSecureMessageError, updateSecureMessage]);
  const globalState = useSelector((state) => state);
  const lang = localStorage.getItem('language') == 'fr' ? 'fr' : 'en';
  console.log('globalState', globalState);

  return (
    <div>
      {rb_secure_message && accountDetails && !secureMessageLoading ? (
        <div className="bg-bg-body py-4 md:px-8 px-4 h-full flex flex-col">
          <Breadcrumbs items={breadcrumbs} />

          <main className="bg-white md:p-[30px] p-[10px] rounded-lg shadow-none flex-1 flex-col overflow-y-scroll scrollbar-hide w-full">
            <div className="flex justify-between item-start md:items-center flex-col md:flex-row">
              <div className="text-[16px] md:text-[22px] font-[550]">
                <div className="block xl:inline mt-[15px] md:mt-0">
                  <span
                    aria-label={renderDescriptionParagraphs(
                      productWithCardLast4,
                      undefined,
                      true
                    )}
                    className="inline text-[16px] xl:text-[22px] xl:font-[550] font-[400]"
                  >
                    {renderDescriptionParagraphs(productWithCardLast4)}
                  </span>
                  {/* <span
                    aria-label={accountDetails?.customer?.cardLast4}
                    className="inline text-[16px] xl:text-[22px] xl:font-[550] font-[400]"
                  >
                    {renderDescriptionParagraphs(accountDetails?.customer?.cardLast4," ")}
                  </span> */}
                </div>
              </div>

              <Button
                ariaLabel={rb_secure_message?.newMessageButtonLabel}
                variant={'secondary'}
                onClick={() => {
                  handleButtonClick();
                }}
                // href={featureFlaggingData ? buttonLink : '#'}
                className={`w-max md:w-auto h-[40px] p-3 bg-white text-primary-red border-primary-red border-2 text-sm font-medium py-2 px-4 mt-[15px] md:mt-0`}
              >
                {rb_secure_message?.newMessageButtonLabel}
              </Button>
            </div>
            {localMessages && localMessages.length > 0 ? (
              <div className="flex flex-1 w-full gap-[15px] mt-[22px]">
                <div className="w-full xl:w-[26%] lg:w-[50%] md:w-[60%] h-[80vh]">
                  <div className="flex flex-col gap-2">
                    {paginatedMessages.map((msg, index) => (
                      <MessageCard
                        key={msg?.confirmationNumber}
                        message={msg}
                        isSelected={selectedMessageIndex === index}
                        onClick={() => {
                          setSelectedMessageIndex(index);
                          handleCardClick(msg?.referenceNumber);
                        }}
                      />
                    ))}
                  </div>
                  {localMessages.length > 5 && (
                    <Pagination
                      pageCount={Math.ceil(localMessages.length / itemsPerPage)}
                      forcePage={currentPage}
                      onPageChange={(selected) => setCurrentPage(selected)}
                    />
                  )}
                </div>
                <div className="h-[80vh] w-[74%] hidden md:block border border-light-gray-border rounded-2xl">
                  <ViewMessageDetail messageId={selectedMessageId} />
                </div>
              </div>
            ) : (
              <div className=" flex justify-center items-center w-full h-[80vh] border border-light-gray-border bg-white rounded-2xl mt-[12px]">
                <div
                  className="flex flex-col gap-2 items-center justify-center"
                  aria-live="polite"
                >
                  <p
                    className="text-[16px] font-[500] text-[#666]"
                    aria-label={rb_secure_message?.noMessagesAvailable}
                  >
                    {' '}
                    {rb_secure_message?.noMessagesAvailable}
                  </p>
                  <p
                    className="text-[16px] font-[350] text-[#666]"
                    aria-label={rb_secure_message?.noMessagesAvailableDesc}
                  >
                    {rb_secure_message?.noMessagesAvailableDesc}
                  </p>
                </div>
              </div>
            )}
          </main>
        </div>
      ) : (
        <div className="flex justify-center items-center h-[80vh]">
          <Spinner aria-label="Loading statements" />
        </div>
      )}

      {isInvalidError && (
        <SuccessModel
          isOpen={isInvalidError}
          title={rb_secure_message?.secureMessageErrorInfo?.weAreSorry}
          subTitle={rb_secure_message?.secureMessageErrorInfo?.looksLikeYouAre}
          successIcon={false}
          closeModal={handelSuccessErrorClose}
          errorIcon={false}
        />
      )}

      {isgenericApierror && (
        <SuccessModel
          isOpen={isgenericApierror}
          title={entries?.rb_error?.genericApiFailure?.header}
          subTitle={entries?.rb_error?.genericApiFailure?.text}
          successIcon={false}
          closeModal={handelSuccessErrorClose}
          errorIcon={false}
        />
      )}
      {sucsessBannerVisible || errorBannerVisible ? (
        <SuccessModel
          isOpen={sucsessBannerVisible || errorBannerVisible}
          title={secureMessageOptionsError ? errorDetails?.title : title}
          subTitle={
            secureMessageOptionsError ? errorDetails?.message : subTitle
          }
          successIcon={sucsessBannerVisible ? true : false}
          closeModal={handelSuccessErrorClose}
          errorIcon={errorBannerVisible ? true : false}
        />
      ) : (
        <Modal
          isOpen={modalIsOpen}
          onRequestClose={closeModal}
          contentLabel="Create new message"
          className="fixed inset-0 flex items-center justify-center z-50 outline-none"
          overlayClassName="fixed inset-0 bg-black bg-opacity-50"
          ariaHideApp={false}
          shouldCloseOnOverlayClick={true}
          aria={{
            labelledby: 'create-new-message',
          }}
        >
          <div
            role="dialog"
            aria-labelledby="create-new-message"
            className="h-[100vh] rounded-none md:h-[80vh] overflow-y-auto relative bg-white md:rounded-lg shadow-lg w-full md:w-[55%] xl:w-[35%] lg:w-[55%] mx-auto p-6 focus:outline-none"
          >
            <button
              onClick={closeModal}
              className="absolute top-4 right-4 text-gray-500 hover:text-black"
              aria-label="Close modal"
            >
              &#x2715;
            </button>
            <GoogleReCaptchaProvider
              reCaptchaKey={environment.recaptchaSiteKey}
              language={lang}
              container={{
                parameters: {
                  badge: 'bottomright',
                  theme: 'light',
                },
              }}
              scriptProps={{ async: true, defer: true }}
            >
              <CreateMessage
                closeModal={closeModal}
                fetchMessages={fetchMessages}
              />
            </GoogleReCaptchaProvider>
          </div>
        </Modal>
      )}

      {/* //mobile view message details modal */}

      {isMobile && (
        <Modal
          isOpen={viewDetailModalOpen}
          onRequestClose={() => setViewDetailModalOpen(false)}
          contentLabel="View Message Detail"
          className="fixed inset-0 flex items-center justify-center z-50 outline-none"
          overlayClassName="fixed inset-0 bg-black bg-opacity-50"
          ariaHideApp={false}
          shouldCloseOnOverlayClick={true}
        >
          <div
            role="dialog"
            aria-labelledby="view-message-detail"
            className="h-[100vh] relative bg-white w-full overflow-y-auto"
          >
            <button
              onClick={() => setViewDetailModalOpen(false)}
              className="absolute top-4 right-4 text-gray-500 hover:text-black"
              aria-label="Close modal"
            >
              &#x2715;
            </button>
            <ViewMessageDetail messageId={selectedMessageId} />
          </div>
        </Modal>
      )}
    </div>
  );
};

export default SecureMessage;
